import { Component, ElementRef, OnChanges, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Rule } from '../services/capd.model';
import { RulesService } from '../services/rules.service';

declare var $: any;

@Component({
  selector: 'company-rule-modal',
  templateUrl: './company-rule-modal.component.html',
  // inputs: ['rule', 'scope']
})

/**
 * The rule preview view at the company level.  These rules can be modified,
 * and thus have interactive parts.
 */
export class CompanyRuleModalComponent implements OnChanges, OnDestroy {
  @Output() update: EventEmitter<any> = new EventEmitter();
  root: string;
  userScope: string;
  @Input() scope: string;
  @Input() rule: any;
  env: number[] = [];
  customRule: Rule = null;
  oldRule: Rule = null;
  private sub: any;

  constructor(private _service: RulesService,
              private _route: ActivatedRoute,
              private _el: ElementRef) {}

  /**
   * Checks to see if a rule has been changed from its original state.
   *
   * @func isUnchanged
   * @returns true if the rule has NOT been changed; false otherwise.
   */
  isUnchanged() {
    return (JSON.stringify(this.oldRule) === JSON.stringify(this.customRule));
  }

  /**
   * Gets the company and tries to find its edited rule.
   * Also sets the render environment.
   *
   * @async
   * @func ngOnChanges
   */
  ngOnChanges() {
    this.userScope = sessionStorage.getItem('scope');
    this.sub = this._route.params.subscribe(params => {
      if (this.rule) {
        this.customRule = this.rule;
        this.oldRule = JSON.parse(JSON.stringify(this.rule));
        this.root = params.id;
        let renderEnvironmentList = this.customRule.renderEnvironment.split(" ");
        if (!this.customRule.renderEnvironment ||
            renderEnvironmentList.indexOf('Default') > -1 ||
            renderEnvironmentList.indexOf('Hcc') > -1) { this.env.push(0); }
        if (renderEnvironmentList.indexOf('Notereader') > -1) {this.env.push(1); }
        if ((this.customRule.renderEnvironment ||
            renderEnvironmentList.indexOf('Default') < 0 ||
            renderEnvironmentList.indexOf('Hcc') < 0) && renderEnvironmentList.indexOf('Notereader') < 0 ) {this.env = []; }
      }
    });
  }

  /**
   * Saves a customized version of the rule.
   *
   * @async
   * @func onSubmit
   */
  onSubmit() {
    this._service.saveCustomRule(this.customRule, this.root).then(() => {
      this.update.emit(null);
      $(this._el.nativeElement).find('#modal-rule-details').hide();
    });
  }

  /**
   * Cancels the action, returning the rule to its previous state.
   *
   * @func onCancel
   */
  onCancel() {
    this.rule = JSON.parse(JSON.stringify(this.oldRule));
  }

  /**
   * Disposes of the subscription object.
   *
   * @async
   * @func ngOnDestroy
   */
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
